import usePostCodes from './usePostCodes';

export default usePostCodes;
